<template>
  <form>
    <md-card>
      <md-card-header class="md-card-header-text md-card-header-primary">
        <div class="card-text" style="display: block;background: grey;">
          <!--<md-icon>list_alt</md-icon>-->
          <h4 class="title" style="color: white;">{{ $t("User Profile") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-80">
            <md-field>
              <label>{{ $t("Email Address") }}</label>
              <md-input v-model="email" type="email" disabled></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20 md-small-hide"></div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <md-field>
              <label>{{ $t("First Name") }}</label>
              <md-input
                name="firstname"
                data-vv-name="firstname"
                v-model="firstname"
                required
                v-validate="'required|min:2'"
                type="text"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-40">
            <md-field>
              <label>{{ $t("Last Name") }}</label>
              <md-input
                name="lastname"
                data-vv-name="lastname"
                v-model="lastname"
                required
                v-validate="'required|min:2'"
                type="text"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20 md-small-hide"></div>
          <div class="md-layout-item md-small-size-100 md-size-80">
            <md-field>
              <label>{{ $t("Address") }}</label>
              <md-input
                name="street"
                data-vv-name="street"
                v-model="street"
                v-validate="'min:3'"
                type="text"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20 md-small-hide"></div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>{{ $t("City") }}</label>
              <md-input
                name="city"
                data-vv-name="city"
                v-model="city"
                v-validate="'min:3'"
                type="text"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-10">
            <md-field>
              <label>{{ $t("Province") }}</label>
              <md-input
                v-model="province"
                name="province"
                v-validate="{
                  required: false,
                  regex: /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/
                }"
                data-vv-name="province"
                id="province"
                type="text"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label>{{ $t("Postal Code") }}</label>
              <md-input
                name="postalcode"
                data-vv-name="postalcode"
                v-model="postalcode"
                v-validate="{
                  required: false,
                  regex: /^([A-Z][0-9][A-Z] [0-9][A-Z][0-9])$/
                }"
                type="text"
                v-mask="'A#A #A#'"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-30">
            <md-field>
              <label>{{ $t("Telephone") }}</label>
              <md-input
                name="phone"
                data-vv-name="phone"
                v-model="phone"
                v-validate="'min:17'"
                type="text"
                v-mask="'+1 (###) ###-####'"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20 md-small-hide"></div>
          <div class="md-layout-item md-size-100 text-right ">
            <md-button
              :disabled="errors.any()"
              @click="showProfileEditor"
              class="md-raised md-primary mt-4"
              >{{ $t("Edit Profile") }}</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>

    <modal
      style="transform: translate3d(100%, 0px, 0px);"
      v-if="editingProfile"
    >
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeProfileEditor"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>perm_identity</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("User Profile") }}
            </h4>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field>
                  <label>{{ $t("Email Address") }}</label>
                  <md-input v-model="email" type="email" disabled></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field
                  :class="[
                    {
                      'md-valid': !errors.has('firstname') && touched.firstname
                    },
                    {
                      'md-error':
                        errors.has('firstname') && firstname.length === 0
                    }
                  ]"
                >
                  <label>{{ $t("First Name") }}</label>
                  <md-input
                    name="firstname"
                    data-vv-name="firstname"
                    v-model="firstname"
                    required
                    v-validate="'required|min:2'"
                    type="text"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('firstname') && firstname.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('firstname') &&
                          touched.firstname &&
                          firstname.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field
                  :class="[
                    {
                      'md-valid':
                        !errors.has('lastname') &&
                        touched.lastname &&
                        lastname.length > 0
                    },
                    {
                      'md-error':
                        errors.has('lastname') && lastname.length === 0
                    }
                  ]"
                >
                  <label>{{ $t("Last Name") }}</label>
                  <md-input
                    name="lastname"
                    data-vv-name="lastname"
                    v-model="lastname"
                    required
                    v-validate="'required|min:2'"
                    type="text"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('lastname') && lastname.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('lastname') &&
                          touched.lastname &&
                          lastname.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field
                  :class="[
                    {
                      'md-valid':
                        !errors.has('street') &&
                        touched.street &&
                        street.length > 0
                    },
                    { 'md-error': errors.has('street') && street.length === 0 }
                  ]"
                >
                  <label>{{ $t("Address") }}</label>
                  <md-input
                    name="street"
                    data-vv-name="street"
                    v-model="street"
                    v-validate="'required|min:6'"
                    type="text"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('street') && street.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('street') &&
                          touched.street &&
                          street.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field
                  :class="[
                    {
                      'md-valid':
                        !errors.has('city') && touched.city && city.length > 0
                    },
                    { 'md-error': errors.has('city') && city.length === 0 }
                  ]"
                >
                  <label>{{ $t("City") }}</label>
                  <md-input
                    name="city"
                    data-vv-name="city"
                    v-model="city"
                    v-validate="'required|min:3'"
                    type="text"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('city') && city.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('city') && touched.city && city.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-autocomplete
                  v-model="province"
                  name="province"
                  v-validate="{
                    required: true,
                    regex: /^(AB|BC|MB|NB|NL|NT|NS|NU|ON|PE|QC|SK|YT)$/
                  }"
                  data-vv-name="province"
                  id="province"
                  :md-options="provinces"
                  :class="[
                    {
                      'md-valid':
                        !errors.has('province') &&
                        touched.province &&
                        province.length > 0
                    },
                    {
                      'md-error':
                        errors.has('province') && province.length === 0
                    }
                  ]"
                >
                  <label>{{ $t("Province") }}</label>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('province') && province.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('province') &&
                          touched.province &&
                          province.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-autocomplete>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-50">
                <md-field
                  :class="[
                    {
                      'md-valid':
                        !errors.has('postalcode') &&
                        touched.postalcode &&
                        postalcode.length > 0
                    },
                    {
                      'md-error':
                        errors.has('postalcode') && postalcode.length === 0
                    }
                  ]"
                >
                  <label>{{ $t("Postal Code") }}</label>
                  <md-input
                    name="postalcode"
                    data-vv-name="postalcode"
                    v-model="postalcode"
                    v-validate="{
                      required: true,
                      regex: /^([A-Z][0-9][A-Z] [0-9][A-Z][0-9])$/
                    }"
                    type="text"
                    v-mask="'A#A #A#'"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="
                        errors.has('postalcode') && postalcode.length === 0
                      "
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('postalcode') &&
                          touched.postalcode &&
                          postalcode.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <md-field
                  :class="[
                    {
                      'md-valid':
                        !errors.has('phone') &&
                        touched.phone &&
                        phone.length > 0
                    },
                    { 'md-error': errors.has('phone') && phone.length === 0 }
                  ]"
                >
                  <label>{{ $t("Telephone") }}</label>
                  <md-input
                    name="phone"
                    data-vv-name="phone"
                    v-model="phone"
                    v-validate="'required|min:17'"
                    type="text"
                    v-mask="'+1 (###) ###-####'"
                  ></md-input>
                  <slide-y-down-transition>
                    <md-icon
                      class="error"
                      v-show="errors.has('phone') && phone.length === 0"
                      >close</md-icon
                    >
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon
                      class="success"
                      v-show="
                        !errors.has('phone') &&
                          touched.phone &&
                          phone.length > 0
                      "
                      >done</md-icon
                    >
                  </slide-y-down-transition>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          class="md-success md-simple"
          @click="updateProfile"
          :disabled="errors.any()"
          >{{ $t("Update") }}</md-button
        >
      </template>
    </modal>
  </form>
</template>
<script>
import { Modal } from "@/components";
import { mapFields } from "vuex-map-fields";
import { provinces } from "@/const.js";
import { SlideYDownTransition } from "vue2-transitions";
import { mask } from "vue-the-mask";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  $_veeValidate: {
    validator: "new"
  },
  directives: { mask },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    Modal,
    SlideYDownTransition
  },
  computed: {
    ...mapFields("auth", [
      "email",
      "newsletter",
      "firstname",
      "lastname",
      "phone",
      "company",
      "street",
      "city",
      "province",
      "postalcode"
    ])
  },
  data() {
    return {
      provinces: null,
      editingProfile: false,
      touched: {
        firstname: false,
        lastname: false,
        phone: false,
        company: false,
        street: false,
        city: false,
        province: false,
        postalcode: false
      }
    };
  },
  watch: {
    firstname() {
      this.touched.firstname = true;
    },
    lastname() {
      this.touched.lastname = true;
    },
    phone() {
      this.touched.phone = true;
    },
    company() {
      this.touched.company = true;
    },
    street() {
      this.touched.street = true;
    },
    city() {
      this.touched.city = true;
    },
    province() {
      this.touched.province = true;
    },
    postalcode() {
      this.touched.postalcode = true;
    }
  },
  mounted() {
    this.provinces = provinces;
    EventBus.$on("updatedUserProfile", () => {
      swal.fire({
        title: "You successfully updated profile!",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
      this.editingProfile = false;
    });
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateProfile() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$store.dispatch("auth/editUserProfile");
        }
        return res;
      });
    },
    showProfileEditor() {
      this.editingProfile = true;
    },
    closeProfileEditor() {
      this.$store.dispatch("auth/getUserProfile");
      this.editingProfile = false;
    }
  },
  beforeDestroy() {
    EventBus.$off("updatedUserProfile");
  }
};
</script>
<style>
@media screen and (max-width: 400px) {
}
</style>
